export default {
    GET_QUEUED_BOOKINGS: state => state.queuedBookings,
    GET_SELECTED_QUEUED_BOOKING: state => state.selectedQueuedBooking,
    GET_QUEUED_BOOKING_SUBMITTED: state => state.queuedBookingSubmitted,
}